export const COLLECTION_COMPACTACAO = "tblEnsaiosCompactacao";
export const COLLECTION_CILINDROS = "tblCompactacaoCilindros";
export const COLLECTION_CAPSULAS = "tblCompactacaoCapsulas";
export const COLLECTION_FAIXAS_DNIT = "tblCompactacaoFaixasDnit";

export const tiposCapsula = [
  { value: "higroscopica", label: "Higroscópica" },
  { value: "limite_liquidez", label: "Limite de Liquidez" },
  { value: "limite_plasticidade", label: "Limite de Plasticidade" },
];

export const peneirasSolo = [
  { nome: '4"', abertura: "101,8" },
  { nome: '3 1/2"', abertura: "88,9" },
  { nome: '3"', abertura: "76,2" },
  { nome: '2 1/2"', abertura: "63,5" },
  { nome: '2"', abertura: "50,8" },
  { nome: '1 1/2"', abertura: "38,1" },
  { nome: '1"', abertura: "25,4" },
  { nome: '3/4"', abertura: "19,0" },
  { nome: '1/2"', abertura: "12,7" },
  { nome: '3/8"', abertura: "9,5" },
  { nome: "4", abertura: "4,8" },
  { nome: "8", abertura: "2,4" },
  { nome: "10", abertura: "2,0" },
  { nome: "16", abertura: "1,2" },
  { nome: "30", abertura: "0,6" },
  { nome: "40", abertura: "0,42" },
  { nome: "50", abertura: "0,3" },
  { nome: "60", abertura: "0,25" },
  { nome: "100", abertura: "0,15" },
  { nome: "200", abertura: "0,075" },
  { nome: "Fundo", abertura: "" },
];

export const faixasDnitPadrao = [
  ['2"', "50,8", "100", "100", "100", "100", "", "", "", "", "", "", "", "", "± 7"],
  ['1"', "25,4", "", "", "75", "90", "100", "100", "100", "100", "100", "100", "100", "100", "± 7"],
  ['3/8"', "9,5", "30", "65", "40", "75", "50", "85", "60", "100", "", "", "", "", "± 7"],
  ["4", "4,8", "25", "55", "30", "60", "35", "65", "50", "85", "55", "100", "70", "100", "± 5"],
  ["10", "2,0", "15", "40", "20", "45", "25", "50", "40", "70", "40", "100", "55", "100", "± 5"],
  ["40", "0,42", "8", "20", "15", "30", "15", "30", "25", "45", "20", "50", "30", "70", "± 2"],
  ["200", "0,074", "2", "8", "5", "15", "5", "15", "10", "25", "6", "20", "8", "25", "± 2"],
].map(([peneira, mm, aMin, aMax, bMin, bMax, cMin, cMax, dMin, dMax, eMin, eMax, fMin, fMax, tolerancia], ordem) => ({
  ordem,
  peneira,
  mm,
  A: { min: aMin, max: aMax },
  B: { min: bMin, max: bMax },
  C: { min: cMin, max: cMax },
  D: { min: dMin, max: dMax },
  E: { min: eMin, max: eMax },
  F: { min: fMin, max: fMax },
  tolerancia,
}));

export const penetracoesCBR = [
  { mm: "0,63", tempo: "0,5" },
  { mm: "1,27", tempo: "1,0" },
  { mm: "1,90", tempo: "1,5" },
  { mm: "2,54", tempo: "2,0" },
  { mm: "3,81", tempo: "3,0" },
  { mm: "5,08", tempo: "4,0" },
  { mm: "6,35", tempo: "5,0" },
  { mm: "7,62", tempo: "6,0" },
  { mm: "8,89", tempo: "7,0" },
  { mm: "10,16", tempo: "8,0" },
  { mm: "12,70", tempo: "10,0" },
];

export function numero(valor) {
  if (valor === null || valor === undefined || valor === "") return null;
  const tratado = String(valor).replace(/\./g, "").replace(",", ".");
  const convertido = Number(tratado);
  return Number.isFinite(convertido) ? convertido : null;
}

export function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

export function criarPontosCompactacao(qtd = 5) {
  return Array.from({ length: qtd }, (_, index) => ({
    id: index + 1,
    cilindroId: "",
    cilindro: "",
    capsulaId: "",
    capsula: "",
    golpes: "",
    agua: "",
    pesoSoloUmidoMolde: "",
    umidade: "",
    densidadeUmida: "",
    densidadeSeca: "",
  }));
}

export function criarExpansao(qtd = 5) {
  return Array.from({ length: qtd }, (_, index) => ({
    id: index + 1,
    cilindroId: "",
    cilindro: "",
    alturaCilindro: "",
    dataInicial: "",
    horaInicial: "",
    leituraInicial: "",
    leiturasDiarias: Array.from({ length: 3 }, () => ({
      data: "",
      hora: "",
      leitura: "",
    })),
    dataFinal: "",
    horaFinal: "",
    leituraFinal: "",
    diferenca: "",
    expansao: "",
  }));
}

function adicionarDiasData(data, dias) {
  if (!data) return "";

  const [ano, mes, dia] = String(data).split("-").map(Number);
  if (!ano || !mes || !dia) return "";

  const dataCalculada = new Date(Date.UTC(ano, mes - 1, dia + dias));
  return dataCalculada.toISOString().slice(0, 10);
}

export function sincronizarDatasExpansao(expansao = [], dataCompactacao = "") {
  return criarExpansao(5).map((modelo, index) => {
    const linhaAtual = expansao[index] || {};
    const leiturasAtuais = linhaAtual.leiturasDiarias || [];

    return {
      ...modelo,
      ...linhaAtual,
      dataInicial: dataCompactacao || "",
      leiturasDiarias: modelo.leiturasDiarias.map((leitura, leituraIndex) => ({
        ...leitura,
        ...(leiturasAtuais[leituraIndex] || {}),
        data: adicionarDiasData(dataCompactacao, (leituraIndex + 1)),
      })),
      dataFinal: adicionarDiasData(dataCompactacao, 4),
    };
  });
}

export function criarCBR(qtd = 5) {
  return Array.from({ length: qtd }, (_, index) => ({
    id: index + 1,
    cilindroId: "",
    cilindro: "",
    aplicarCorrecao: false,
    correcaoCbrMm: "",
    leituras: penetracoesCBR.map((ponto) => ({ ...ponto, leitura: "", pressao: "", correcao: "" })),
    isc254: "",
    isc508: "",
    isc: "",
  }));
}

export function criarGranulometria() {
  return peneirasSolo.map((peneira) => ({
    ...peneira,
    pesoRetido: "",
    percentualRetido: "",
    acumulado: "",
    percentualPassante: "",
    faixaDnit: "",
    faixaDnitMin: "",
    faixaDnitMax: "",
  }));
}

export function criarLimites() {
  return {
    tipoPesoPlasticidade: "tampa",
    escalaGraficoLiquidez: {
      golpesMin: "10",
      golpesMax: "50",
      umidadeMin: "25",
      umidadeMax: "50",
    },
    liquidez: Array.from({ length: 5 }, (_, index) => ({
      id: index + 1,
      capsulaId: "",
      capsula: "",
      tampa: "",
      capsulaSoloAgua: "",
      capsulaSolo: "",
      agua: "",
      pesoCapsula: "",
      solo: "",
      umidade: "",
      golpes: "",
    })),
    plasticidade: Array.from({ length: 5 }, (_, index) => ({
      id: index + 1,
      capsulaId: "",
      capsula: "",
      tampa: "",
      capsulaSoloAgua: "",
      capsulaSolo: "",
      agua: "",
      pesoCapsula: "",
      solo: "",
      umidade: "",
    })),
    resultados: {
      limiteLiquidez: "",
      limitePlasticidade: "",
      indicePlasticidade: "",
      equivalenteAreia: "",
      massaEspecificaReal: "",
      densidadeSolta: "",
    },
  };
}

export function criarSubstituicaoSolo() {
  return {
    pesoRetidoTresQuartos: "",
    pesoRetidoNumero4: "",
    pesoPassanteNumero4: "",
    pesoAmostraCompactacao: "",
    pesoAmostraGranulometria: "",
  };
}

export const estadoInicialCompactacao = {
  codigo: "",
  empresa: "",
  cliente: "",
  clienteId: "",
  obra: "",
  obraId: "",
  camadaEstudo: "",
  material: "",
  materialId: "",
  materialCodigo: "",
  materialFornecedor: "",
  localColeta: "",
  registroNumero: "",
  dataEnsaio: "",
  operador: "",
  observacao: "",
  espessuraDisco: "63,5",
  camadas: "5",
  compactacao: criarPontosCompactacao(),
  expansao: criarExpansao(),
  cbr: criarCBR(),
  granulometria: {
    umidadeHigroscopica: [
      { capsulaId: "", capsula: "", capsulaSoloAgua: "", capsulaSolo: "", agua: "", pesoCapsula: "", solo: "", umidade: "" },
      { capsulaId: "", capsula: "", capsulaSoloAgua: "", capsulaSolo: "", agua: "", pesoCapsula: "", solo: "", umidade: "" },
    ],
    amostraSeca: {
      amostraTotalUmida: "",
      soloSecoRetido10: "",
      soloUmidoPassante10: "",
      soloSecoPassante10: "",
      amostraTotalSeca: "",
      amostraMenor10Umida: "",
      amostraMenor10Seca: "",
    },
    peneiramento: criarGranulometria(),
    classificacaoIg: "",
    classificacaoTrb: "",
    classificacaoSucs: "",
  },
  limites: criarLimites(),
  substituicaoSolo: criarSubstituicaoSolo(),
  resultados: {
    densidadeMaxima: "",
    umidadeOtima: "",
    isc: "",
    expansao: "",
  },
};

export function calcularPontoCompactacao(ponto, cilindro) {
  const volume = numero(cilindro?.volume);
  const pesoMolde = numero(cilindro?.peso);
  const pesoSoloUmidoMolde = numero(ponto.pesoSoloUmidoMolde);
  const umidade = numero(ponto.umidade);
  const densidadeUmida =
    volume && pesoMolde !== null && pesoSoloUmidoMolde !== null
      ? (pesoSoloUmidoMolde - pesoMolde) / volume
      : numero(ponto.densidadeUmida);
  const densidadeSeca =
    densidadeUmida !== null && umidade !== null ? densidadeUmida / (1 + umidade / 100) : numero(ponto.densidadeSeca);

  return {
    ...ponto,
    cilindro: cilindro?.numero || ponto.cilindro || "",
    densidadeUmida: densidadeUmida === null ? ponto.densidadeUmida : densidadeUmida.toFixed(3),
    densidadeSeca: densidadeSeca === null ? ponto.densidadeSeca : densidadeSeca.toFixed(3),
  };
}

export function recalcularResultados(form) {
  const pontos = (form.compactacao || [])
    .map((ponto) => ({ umidade: numero(ponto.umidade), densidadeSeca: numero(ponto.densidadeSeca) }))
    .filter((ponto) => ponto.umidade !== null && ponto.densidadeSeca !== null);
  const maior = pontos.reduce((selecionado, ponto) => {
    if (!selecionado || ponto.densidadeSeca > selecionado.densidadeSeca) return ponto;
    return selecionado;
  }, null);

  const valoresIsc = (form.cbr || []).map((linha) => numero(linha.isc)).filter((valor) => valor !== null);
  const valoresExpansao = (form.expansao || []).map((linha) => numero(linha.expansao)).filter((valor) => valor !== null);

  return {
    densidadeMaxima: maior ? maior.densidadeSeca.toFixed(3) : form.resultados?.densidadeMaxima || "",
    umidadeOtima: maior ? maior.umidade.toFixed(1) : form.resultados?.umidadeOtima || "",
    isc: valoresIsc.length ? (valoresIsc.reduce((soma, valor) => soma + valor, 0) / valoresIsc.length).toFixed(1) : form.resultados?.isc || "",
    expansao: valoresExpansao.length
      ? (valoresExpansao.reduce((soma, valor) => soma + valor, 0) / valoresExpansao.length).toFixed(2)
      : form.resultados?.expansao || "",
  };
}
